<template>
 
  <footer>
    <Container fluid>
      <Div class="row justify-content-center">
        <Div class="col-md-11">
          <hr />
        </Div>
      </Div>

      
      <Div class="row justify-content-center">
        <Div class="col-md-3">
          <p>&copy; {{ new Date().getFullYear() }} {{ $t("adresseName") }}</p>
          <P class="fw-bold"
            ><a href="https://Pillarsoft.de" class="footerLink" target="_blank">
              <span style="height: 70px; padding-top: 10px; margin-top: -10px">
                {{ $t("Webdesign by Pillarsoft.de") }}</span
              ></a
            ></P
          >
        </Div>
      </Div>
      
    </Container>
  </footer>
</template>

<script>
import "bootstrap-icons/font/bootstrap-icons.css";
//import { computed } from 'vue';

//const currentYear = computed(() => new Date().getFullYear());

export default {
  name: "AppFooter",
  data() {
    return {
      HomepageCookiePillarSoft: "",
    };
  },
  methods: {
   
  },
  mounted() {
    // Cookie auslesen
    this.HomepageCookiePillarSoft = this.$cookies.get("HomepageCookiePillarSoft");
    console.log("HomepageCookiePillarSoft:", this.HomepageCookiePillarSoft);
  },
};
</script>
